module.exports = __webpack_public_path__ + "img/cleric.45ee6ef8.png";